export default __webpack_public_path__ + "static/media/blog-post-layout-01-img-06.ae348692.jpg";